/**
 * @method: to call reducer
 */
 import { actionType } from "../nonSubscriber/action"; 
 import defaultState from '../defaultStore';
 let defaultStore = defaultState;
  const reducer = (state = defaultStore, action) => {
     
    switch (action.type) {
      case actionType.GET_NON_SUBSCRIBER_REQUEST:
           return { ...state };
      case actionType.GET_NON_SUBSCRIBER_RECEIVED:
          defaultState.nonSubscriber =  action.payload
          state = {
               ...state,
               ...defaultState.nonSubscriber
          };          
          return state;
          case actionType.GET_ERROR_PAGE_REQUEST:
               return { ...state };
          case actionType.GET_ERROR_PAGE_RESPONSE:
              defaultState.nonSubscriber =  action.payload
              state = {
                   ...state,
                   ...defaultState.nonSubscriber
              };          
              return state;
      default: 
           return state;
    }
   };
   export default reducer;